var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOneHundredMini(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0767 14.254C16.8531 14.7579 15.0838 13.3465 14.7956 9.93937C14.5211 6.52844 16.0164 4.42531 18.24 3.92142C20.44 3.4389 22.2466 4.82511 22.531 8.2185C22.8093 11.6431 21.2767 13.7715 19.0767 14.254ZM18.9394 12.5485C20.1647 12.2796 20.7427 10.9651 20.5541 8.65336C20.3692 6.35529 19.6025 5.35797 18.3811 5.64059C17.101 5.92485 16.5739 7.21026 16.7587 9.50833C16.9474 11.8201 17.6768 12.8426 18.9394 12.5485Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5266 16.6453C8.30302 17.1492 6.53372 15.7378 6.24551 12.3307C5.971 8.91973 7.46636 6.81661 9.68994 6.31272C11.89 5.8302 13.6965 7.2164 13.9809 10.6098C14.2592 14.0344 12.7266 16.1628 10.5266 16.6453ZM10.3893 14.9398C11.6146 14.6709 12.1927 13.3564 12.004 11.0447C11.8192 8.74659 11.0525 7.74926 9.83103 8.03189C8.55094 8.31614 8.02386 9.60156 8.20869 11.8996C8.39735 14.2114 9.12679 15.2339 10.3893 14.9398Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.590503 9.9529L3.42666 8.2579L4.81094 7.87061L5.60655 17.8452L3.68776 18.382L3.04523 10.4336L0.72882 11.8206L0.590503 9.9529Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1374 1.33076C21.2312 1.68261 21.0253 2.04507 20.6775 2.14033L1.36736 7.42948C1.01955 7.52475 0.661521 7.31674 0.567688 6.96489C0.473854 6.61304 0.679746 6.25058 1.02756 6.15531L20.3377 0.866172C20.6855 0.770904 21.0435 0.978905 21.1374 1.33076Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0124 15.0353C23.1062 15.3871 22.9003 15.7496 22.5525 15.8449L3.24236 21.134C2.89455 21.2293 2.53652 21.0213 2.44269 20.6694C2.34885 20.3176 2.55475 19.9551 2.90256 19.8598L22.2127 14.5707C22.5605 14.4754 22.9185 14.6834 23.0124 15.0353Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneHundredMini);
export default __webpack_public_path__ + "static/media/oneHundred-mini.33caf56e10475609de1938df1fd9a831.svg";
export { ForwardRef as ReactComponent };